import { THEME_OPTION_DEFAULTS, themeOptions, type ThemeStylesDto } from '@xshop/shared';
import './elementThemeOptions.css';
import './elementHoverMotion.css';

// The theme options a page's stylesheet answers, as marks on the page itself: a card part switched off, a
// card picture's shape. Only an option that differs from what every shop did before is marked, so a store
// that never touched one renders exactly as it did.

// Marks the page with every card option the store or theme has moved away from its default.
export function themeOptionMarks(styles: ThemeStylesDto): Record<string, string> {
  const options = themeOptions(styles);
  const marks: Record<string, string> = {};
  if (!options.cardShowType) marks['data-card-type'] = 'off';
  if (!options.cardShowRating) marks['data-card-rating'] = 'off';
  if (!options.cardHoverImage) marks['data-card-hover'] = 'off';
  if (!options.cardQuickAdd) marks['data-card-quick'] = 'off';
  if (styles.options?.cardRatio) marks['data-card-ratio'] = styles.options.cardRatio;
  if (options.logoWidth > 0) marks['data-logo-width'] = '';
  if (options.cartRule !== THEME_OPTION_DEFAULTS.cartRule) marks['data-cart-rule'] = options.cartRule;
  return marks;
}
